module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAKNJREFUOE9jZKAQMFKon2GIGCAQ89/hPzND1seFjGHoXibKCzyJ/7WY/jKsYmRkuIZuCFEGgGzFZQjcAP64//+JjhFGhtUwl8ANAPmTkAGgcGD4z+DFxMQQ+X4B42aQeqK9wB//fxXjfwab/4wMsR8XMu6FWUaUASDNDP8Z9P4xMCR+XsR4HNmlRBkA0iAY91/v/SLGS2RFI76wIdoFuAwZeAMAGN8vET04tVwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rightArrow.png
// module id = q8gq
// module chunks = 2